import { render, staticRenderFns } from "./CampoTextoBase.vue?vue&type=template&id=e3947f92&scoped=true"
import script from "./CampoTextoBase.vue?vue&type=script&setup=true&lang=js"
export * from "./CampoTextoBase.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CampoTextoBase.vue?vue&type=style&index=0&id=e3947f92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3947f92",
  null
  
)

export default component.exports